export default {
  nome: 'VuexControleAdesao'
}
